import React from 'react';
import Select from './Select';
import { translate } from '../Services/translation';

export interface Language {
  Name: string;
  Url: string;
  LanguageList: Language[];
}

const LanguageSelector = (props: { languageList: Language }) => {
  const { languageList } = props;

  const languageOptions = languageList.LanguageList.map((language) => ({
    value: language.Url,
    label: language.Name,
  }));

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedUrl = e.target.value;

    if (selectedUrl !== languageList.Url) window.location.href = selectedUrl;
  };

  return (
    <div className="flex items-center">
      <div className="green-dot"></div>
      <Select
        options={languageOptions}
        placeholder={languageList.Name}
        onChange={handleSelectChange}
        label={translate('header.select-language')}
        showLabel={false}
        inputSize="x-small"
        wrapperClassName="text-white uppercase"
        selectClassName="language-selector-select uppercase min-w-[6rem] border-none !px-0 focus:outline-white rounded-none underline"
      />
    </div>
  );
};

export default LanguageSelector;
